const TableLoading = (colNum) => (
  <tr key="table_loading">
    <td colSpan={colNum} className="uk-text-center" style={{ padding: "20px" }}>
      <div data-uk-spinner="ratio: 2;"></div>
    </td>
  </tr>
);

export default TableLoading;
